import { Button, Typography } from "@/components/ui";
import { Copy } from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** Detail row for phone / email / address on gradient (client or defendant) profile cards. */
export const GradientCardProfileDetailRow = ({
  icon: Icon,
  label,
  value,
  onCopy,
}: {
  icon: LucideIcon;
  label: string;
  value?: string;
  onCopy?: () => void;
}) => {
  return (
    <div className="flex items-start gap-3">
      <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/10">
        <Icon className="h-4 w-4 text-white" />
      </div>
      <div className="min-w-0 flex-1">
        <Typography className="text-xs font-medium tracking-[0.16em] text-white/60 uppercase">
          {label}
        </Typography>
        <div className="mt-1 flex min-w-0 items-start gap-2">
          <Typography className="min-w-0 text-sm leading-6 break-words text-white">
            {value || "-"}
          </Typography>
          {value && onCopy && (
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="h-7 w-7 shrink-0 rounded-full text-white/70 hover:bg-white/12 hover:text-white"
              onClick={onCopy}
            >
              <Copy className="h-3.5 w-3.5" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
